import { render } from "./Widgets.vue?vue&type=template&id=1bb9ac85"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__